export default __webpack_public_path__ + "static/3-5-0-0-e0e694cc2fcc1f73c8012d299cc67874.jpg";